module.exports = __webpack_public_path__ + "img/opciones.dcc6d0aa.svg";